import React from "react"
import propTypes from "prop-types"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import Loader from "react-loader-spinner"
import Accordion, {
  AccordionItem,
  AccordionHeader,
  AccordionContent
} from "../../../../components/Accordion"
import Answer, {
  AnswerTitle,
  AnswerDescription,
  AnswerEdit
} from "../../../../components/Answer"
import Form, { Group } from "../../../../../../components/Form"
import Button from "../../../../../../components/Button"
import configs from "../../../../../../configs"

const Review = ({ onBack, onGoAt, store: { plan, user } }) => {
  const userIsGuardian = user.list_role.includes(configs.roles.Guardian)

  return plan.loading ? (
    <Loader
      type="TailSpin"
      color="#0c4632"
      height={80}
      width={80}
      className="loader"
    />
  ) : (
    <>
      <div className="pre-plan_header">
        <div className="pre-plan_title">Review Pre-plan</div>
      </div>

      <div className="pre-plan_header">
        <div className="pre-plan_title">About Me</div>
      </div>

      <Form>
        <Accordion className="accordion accordion--dark">
          {plan.answers.supportTeam && !!plan.answers.supportTeam.length && (
            <AccordionItem>
              <AccordionHeader>My Support Team</AccordionHeader>

              <AccordionContent>
                {plan.answers.supportTeam.map(teamMember => (
                  <Answer
                    key={`support-team-${teamMember.id}`}
                    className="answer--dark"
                  >
                    <AnswerTitle>Name</AnswerTitle>
                    <AnswerDescription>
                      {teamMember.first_name} {teamMember.family_name}
                    </AnswerDescription>
                    <AnswerTitle>Relationship</AnswerTitle>
                    <AnswerDescription>
                      {
                        configs.relationship_labes[
                          teamMember.relationship.relationship
                        ]
                      }
                    </AnswerDescription>
                    <AnswerTitle>Support Provided</AnswerTitle>
                    <AnswerDescription>
                      {teamMember.relationship.support_provided}
                    </AnswerDescription>
                    <AnswerEdit
                      href="/#"
                      onClick={e => {
                        onGoAt("support-team", 1, e, teamMember.id)
                      }}
                    >
                      edit
                    </AnswerEdit>
                  </Answer>
                ))}
              </AccordionContent>
            </AccordionItem>
          )}

          {plan.answers.aboutMe && (
            <AccordionItem>
              <AccordionHeader>Support Questions</AccordionHeader>

              <AccordionContent>
                <Answer className="answer--dark">
                  <AnswerTitle>
                    Where I live and the people who support me
                  </AnswerTitle>

                  {plan.answers.aboutMe.support_me ? (
                    <AnswerDescription>
                      {plan.answers.aboutMe.support_me}
                    </AnswerDescription>
                  ) : (
                    <AnswerDescription noAnswer />
                  )}

                  <AnswerEdit
                    href="/#"
                    onClick={e => {
                      onGoAt("about-me", 0, e, 1)
                    }}
                  >
                    edit
                  </AnswerEdit>
                </Answer>

                <Answer className="answer--dark">
                  <AnswerTitle>My daily life</AnswerTitle>

                  {plan.answers.aboutMe.daily_life ? (
                    <AnswerDescription>
                      {plan.answers.aboutMe.daily_life}
                    </AnswerDescription>
                  ) : (
                    <AnswerDescription noAnswer />
                  )}

                  <AnswerEdit
                    href="/#"
                    onClick={e => {
                      onGoAt("about-me", 0, e, 2)
                    }}
                  >
                    edit
                  </AnswerEdit>
                </Answer>

                <Answer className="answer--dark">
                  <AnswerTitle>
                    About me and things that are important
                  </AnswerTitle>

                  {plan.answers.aboutMe.about_me ? (
                    <AnswerDescription>
                      {plan.answers.aboutMe.about_me}
                    </AnswerDescription>
                  ) : (
                    <AnswerDescription noAnswer />
                  )}

                  <AnswerEdit
                    href="/#"
                    onClick={e => {
                      onGoAt("about-me", 0, e, 3)
                    }}
                  >
                    edit
                  </AnswerEdit>
                </Answer>

                <Answer className="answer--dark">
                  <AnswerTitle>My Health and Wellbeing</AnswerTitle>

                  {plan.answers.aboutMe.health_and_wellbeing ? (
                    <AnswerDescription>
                      {plan.answers.aboutMe.health_and_wellbeing}
                    </AnswerDescription>
                  ) : (
                    <AnswerDescription noAnswer />
                  )}

                  <AnswerEdit
                    href="/#"
                    onClick={e => {
                      onGoAt("about-me", 0, e, 4)
                    }}
                  >
                    edit
                  </AnswerEdit>
                </Answer>

                <Answer className="answer--dark">
                  <AnswerTitle>Safety Concerns</AnswerTitle>

                  {plan.answers.aboutMe.safety_concerns ? (
                    <AnswerDescription>
                      {plan.answers.aboutMe.safety_concerns}
                    </AnswerDescription>
                  ) : (
                    <AnswerDescription noAnswer />
                  )}

                  <AnswerEdit
                    href="/#"
                    onClick={e => {
                      onGoAt("about-me", 0, e, 5)
                    }}
                  >
                    edit
                  </AnswerEdit>
                </Answer>

                <Answer className="answer--dark">
                  <AnswerTitle>Communication and Decision making</AnswerTitle>

                  {plan.answers.aboutMe.communication_and_decision_making ? (
                    <AnswerDescription>
                      {plan.answers.aboutMe.communication_and_decision_making}
                    </AnswerDescription>
                  ) : (
                    <AnswerDescription noAnswer />
                  )}

                  <AnswerEdit
                    href="/#"
                    onClick={e => {
                      onGoAt("about-me", 0, e, 6)
                    }}
                  >
                    edit
                  </AnswerEdit>
                </Answer>

                <Answer className="answer--dark">
                  <AnswerTitle>Studying</AnswerTitle>

                  {plan.answers.aboutMe.studying ? (
                    <AnswerDescription>
                      {plan.answers.aboutMe.studying}
                    </AnswerDescription>
                  ) : (
                    <AnswerDescription noAnswer />
                  )}

                  <AnswerEdit
                    href="/#"
                    onClick={e => {
                      onGoAt("about-me", 0, e, 7)
                    }}
                  >
                    edit
                  </AnswerEdit>
                </Answer>

                <Answer className="answer--dark">
                  <AnswerTitle>Transportation</AnswerTitle>

                  {plan.answers.aboutMe.transportation ? (
                    <AnswerDescription>
                      {plan.answers.aboutMe.transportation}
                    </AnswerDescription>
                  ) : (
                    <AnswerDescription noAnswer />
                  )}

                  <AnswerEdit
                    href="/#"
                    onClick={e => {
                      onGoAt("about-me", 0, e, 8)
                    }}
                  >
                    edit
                  </AnswerEdit>
                </Answer>

                <Answer className="answer--dark">
                  <AnswerTitle>Extra Information</AnswerTitle>

                  {plan.answers.aboutMe.extra_info ? (
                    <AnswerDescription>
                      {plan.answers.aboutMe.extra_info}
                    </AnswerDescription>
                  ) : (
                    <AnswerDescription noAnswer />
                  )}

                  <AnswerEdit
                    href="/#"
                    onClick={e => {
                      onGoAt("about-me", 0, e, 9)
                    }}
                  >
                    edit
                  </AnswerEdit>
                </Answer>

                <Answer className="answer--dark">
                  <AnswerTitle>Manage your funds</AnswerTitle>

                  {(() => {
                    switch (plan.answers.aboutMe.fund_management) {
                      case "NDIA":
                        return (
                          <AnswerDescription>
                            Let The NDIA Manage My Funds And Pay My Providers
                          </AnswerDescription>
                        )

                      case "PROF":
                        return (
                          <AnswerDescription>
                            Let A Professional Organisation Manage My Fund
                          </AnswerDescription>
                        )

                      case "SELF":
                        return (
                          <AnswerDescription>
                            I Would Like To Manage My Own Funds
                          </AnswerDescription>
                        )

                      default:
                        return <AnswerDescription noAnswer />
                    }
                  })()}

                  <AnswerEdit
                    href="/#"
                    onClick={e => {
                      onGoAt("managing-funds", 5, e)
                    }}
                  >
                    edit
                  </AnswerEdit>
                </Answer>
              </AccordionContent>
            </AccordionItem>
          )}

          {plan.answers.communityActivities &&
            !!plan.answers.communityActivities.length && (
              <AccordionItem>
                <AccordionHeader>Community Activities</AccordionHeader>

                <AccordionContent>
                  {plan.answers.communityActivities.map(communityActivitie => (
                    <Answer
                      key={`community-activities-${communityActivitie.id}`}
                      className="answer--dark"
                    >
                      <AnswerTitle>Activity Title</AnswerTitle>
                      <AnswerDescription>
                        {communityActivitie.title}
                      </AnswerDescription>

                      <AnswerTitle>
                        How Will This Activity Improve your life
                      </AnswerTitle>
                      <AnswerDescription>
                        {communityActivitie.content}
                      </AnswerDescription>
                      <AnswerEdit
                        href="/#"
                        onClick={e => {
                          onGoAt(
                            "community-activities",
                            2,
                            e,
                            communityActivitie.id
                          )
                        }}
                      >
                        edit
                      </AnswerEdit>
                    </Answer>
                  ))}
                </AccordionContent>
              </AccordionItem>
            )}

          {plan.answers.myGoals && !!plan.answers.myGoals.goal.length && (
            <AccordionItem>
              <AccordionHeader>Support Goals</AccordionHeader>

              <AccordionContent>
                {plan.answers.myGoals.goal.map(goal => (
                  <Answer key={`my-goals-${goal.id}`} className="answer--dark">
                    <AnswerTitle>Goal</AnswerTitle>
                    <AnswerDescription>{goal.title}</AnswerDescription>
                    <AnswerDescription>{goal.content}</AnswerDescription>

                    <AnswerEdit
                      href="/#"
                      onClick={e => {
                        onGoAt("my-goals", 3, e, goal.id)
                      }}
                    >
                      edit
                    </AnswerEdit>
                  </Answer>
                ))}
              </AccordionContent>
            </AccordionItem>
          )}

          {plan.answers.requiredServices &&
            !!plan.answers.requiredServices.length && (
              <AccordionItem>
                <AccordionHeader>Required Services</AccordionHeader>

                <AccordionContent>
                  {plan.answers.requiredServices.map(requiredService => {
                    const key = Object.keys(requiredService)[0]

                    const typesArr = {
                      one_off_purchase: "One Off Purchase",
                      weekly_activity: "Daily or Weekly Services",
                      recurring_activity: "Recurring Activity",
                      recurring_purchase: "Recurring Purchases "
                    }

                    return requiredService[key].map(requiredServiceInner => (
                      <Answer
                        key={requiredServiceInner.id}
                        className="answer--dark"
                      >
                        <AnswerTitle>
                          {typesArr[requiredServiceInner.item_type]}
                        </AnswerTitle>
                        <AnswerTitle>Title</AnswerTitle>
                        <AnswerDescription>
                          {requiredServiceInner.title}
                        </AnswerDescription>
                        <AnswerTitle>Goal #</AnswerTitle>

                        {requiredServiceInner.goals.map(goal => (
                          <AnswerDescription key={`goal-${goal.id}`}>
                            {goal.content}
                          </AnswerDescription>
                        ))}

                        {requiredServiceInner.item_type ===
                          "one_off_purchase" && (
                          <>
                            <AnswerTitle>Cost Range</AnswerTitle>
                            <AnswerDescription>
                              ${requiredServiceInner.item.lower} to $
                              {requiredServiceInner.item.upper}
                            </AnswerDescription>
                          </>
                        )}

                        {requiredServiceInner.item_type === "weekly_activity" &&
                          !!requiredServiceInner.items.length && (
                            <>
                              <AnswerTitle>Dates</AnswerTitle>
                              <AnswerDescription>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>
                                        <div className="answer-field_label">
                                          Days
                                        </div>
                                      </th>
                                      <th>
                                        <div className="answer-field_label">
                                          Hrs
                                        </div>
                                      </th>
                                      <th>
                                        <div className="answer-field_label">
                                          Times
                                        </div>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {requiredServiceInner.items.map(
                                      (date, index) => {
                                        const sKey = `date-${index}-${requiredServiceInner.id}`

                                        return (
                                          <tr key={sKey}>
                                            <td>{date.day}</td>
                                            <td>{date.num_hours}</td>
                                            <td>
                                              {date.start_time}
                                              {date.start_time_period} -{" "}
                                              {date.end_time}
                                              {date.end_time_period}
                                            </td>
                                          </tr>
                                        )
                                      }
                                    )}
                                  </tbody>
                                </table>
                              </AnswerDescription>
                            </>
                          )}

                        {(requiredServiceInner.item_type ===
                          "recurring_activity" ||
                          requiredServiceInner.item_type ===
                            "recurring_purchase") && (
                          <>
                            <AnswerTitle>Cost required</AnswerTitle>
                            <AnswerDescription>
                              ${requiredServiceInner.item.cost_required} every{" "}
                              {
                                configs.frequency_labels[
                                  requiredServiceInner.item.cost_required_period
                                ]
                              }
                            </AnswerDescription>

                            <AnswerTitle>Cost required</AnswerTitle>
                            <AnswerDescription>
                              {requiredServiceInner.item.num_required} times per{" "}
                              {
                                configs.frequency_labels[
                                  requiredServiceInner.item.num_required_period
                                ]
                              }
                            </AnswerDescription>
                          </>
                        )}

                        <AnswerEdit
                          href="/#"
                          onClick={e => {
                            onGoAt(
                              "add-a-service",
                              4,
                              e,
                              requiredServiceInner.id
                            )
                          }}
                        >
                          edit
                        </AnswerEdit>
                      </Answer>
                    ))
                  })}
                </AccordionContent>
              </AccordionItem>
            )}
        </Accordion>

        <Group className="form_group--padding-top-lg">
          {!userIsGuardian && (
            <Button
              routerLink={{
                to: "/pre-plan/congratulations",
                title: "Finish My Review"
              }}
              className="btn--secondary-light btn--width-full btn--height-lg"
            >
              Finish My Review
            </Button>
          )}

          <Button
            button={{ type: "button" }}
            onClick={onBack}
            className="btn--empty-secondary-light btn--width-full btn--height-lg"
          >
            Back
          </Button>
        </Group>
      </Form>
    </>
  )
}

Review.propTypes = {
  onBack: propTypes.func.isRequired,
  onGoAt: propTypes.func.isRequired,
  store: propTypes.shape({
    user: propTypes.shape({
      token: propTypes.string,
      list_role: propTypes.arrayOf(propTypes.number)
    }),
    plan: propTypes.shape({
      loading: propTypes.bool,
      id: propTypes.oneOfType([propTypes.string, propTypes.number]),
      answers: propTypes.shape({
        aboutMe: propTypes.shape({
          support_me: propTypes.string,
          daily_life: propTypes.string,
          about_me: propTypes.string,
          health_and_wellbeing: propTypes.string,
          safety_concerns: propTypes.string,
          communication_and_decision_making: propTypes.string,
          studying: propTypes.string,
          transportation: propTypes.string,
          extra_info: propTypes.string,
          fund_management: propTypes.string
        }),
        supportTeam: propTypes.arrayOf(
          propTypes.shape({
            id: propTypes.string,
            first_name: propTypes.string,
            last_name: propTypes.string,
            email: propTypes.string,
            phone: propTypes.string,
            relationship: propTypes.shape({
              relationship: propTypes.string,
              support_provided: propTypes.string
            })
          })
        ),
        communityActivities: propTypes.arrayOf(
          propTypes.shape({
            id: propTypes.string,
            title: propTypes.string,
            content: propTypes.string
          })
        ),
        myGoals: propTypes.shape({
          goal: propTypes.arrayOf(propTypes.shape({}))
        }),
        requiredServices: propTypes.arrayOf(propTypes.shape({}))
      })
    })
  }).isRequired
}

const mapStateToProps = ({ PlansReducer, AuthenticationReducer }) => ({
  store: {
    user: AuthenticationReducer.user,
    plan: PlansReducer
  }
})

export default withRouter(connect(mapStateToProps)(Review))
